import React, { Component } from "react"
import { Router, Route, Switch } from "react-router-dom"
//css
import "../node_modules/react-toggle-switch/dist/css/switch.min.css"
import "./assets/js/dashboard.js"
import "./assets/css/master.css"
import "bootstrap/dist/css/bootstrap.css"

//redux
import { connect } from "react-redux"
import * as mainAction from "./redux/action/main"
import { bindActionCreators } from "redux"

//services
import { UtilityService } from "./services"

//alert
import AlertContainer from "react-alert"
import Alert from "./components/Common/Alert"

import moment from 'moment'

//Main Layout
import { Header, Sidebar, Footer } from "./components/mainLayout"

import {
  PageNotFound,
  LogInPage,
  // ViewSample,
  // EditSample,
  // EditStyle,
  // ViewStyle,
  GenerateTag,
  // ViewSMV,
  // AddEmbroidery,
  // ListEmbroidery,
  // EditEmbroidery,
  // ViewEmbroidery,
  // EditSMV,
  // ListIB,
  // ViewProduct,
  // EditProduct,
  Costing,
  CostingComparison,
  SystemCategoryList,
  BulkImport,
  Customer, //customer
  MeetingNote,
  // AddMultipleMeeting,
  // ViewMeeting,
  // EditMeeting,
  Dashboard,
  Calendar,
  Communication,
  Chat,
  Style,
  CreateIB,
  Smv_Ov_List,
  SmvThread,
  TechnicalIssues,
  // CostList,
  // ViewCost,
  // EditCost,
  // ListPermissionsRole,
  PermissionRole,
  DevelopmentCAD,
  DevelopmentSourcing,
  DevelopmentProduct,
  DevelopmentFabric,
  DevelopmentBNumber,
  EmployeRights,
  Employee,
  AddCategory,
  // ListDevelopmentProduct,
  // ViewCAD,
  // EditCAD,
  // ViewDevelopmentProduct,
  // EditDevelopmentProduct,
  PrintFabricNumber, //Print Fabric Number,
  SystemSubmodulesPage, //submodule
  Profile, // Profile
  List, //List for all modules
  Trim, //Trim
  Sample, //Sample
  SystemSupplier, //Systemsupplier,
  Report //FabricReport
} from "./pages"

import PrintStyleNumber from "./pages/printStyleNumber/page"

//history
import history from "./containers/history"
import Loading from "./components/Common/Loading"
import MeasurementModal from "./components/SampleRequest/PatternModule/MeasurementModal/MeasurementModal"
import SampleMobileApp from "./pages/Sample/SampleMobileApp/SampleMobileApp"
import MobileLogin from "./pages/Sample/SampleMobileApp/MobileLogin.js"
import MobileQRScanner from "./pages/Sample/SampleMobileApp/MobileQRScanner.js"
import NewEmployee from "./pages/newEmployee/page.js"
import NewSampleRequest from "./pages/newSampleRequest/page.js"
import NewDashboard from "./pages/newDashboard/page.js"
class Routes extends Component {
  state = {
    error: false,
    events: [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
      "touchstart"
    ],
    isMobileOrTablet: this.checkIfMobileOrTablet(),
  }

  componentWillMount() {
    for (var i in this.state.events) {
      window.addEventListener(this.state.events[i], this.resetTimeout)
    }
    this.setTimeout()
  }

  componentWillUnmount() {
    for (var i in this.state.events) {
      window.removeEventListener(this.state.events[i], this.resetTimeout)
    }
  }

  clearTimeout = () => {
    if (this.logoutTimeout) clearTimeout(this.logoutTimeout)
  }

  setTimeout = () => {
    this.logoutTimeout = setTimeout(this.unauthorisedFunc, 15 * 60 * 1000)
  }

  resetTimeout = () => {
    localStorage.setItem("session", Date.now());
    this.clearTimeout()
    this.setTimeout()
  }

  logout = () => {
    // localStorage.removeItem("authToken");
    // localStorage.removeItem("authToken");
    // localStorage.clear();
  // warn = () => {
  //   alert("You will be logged out automatically in 1 minute.");
  // };

    let session = localStorage.getItem("session");
    session = moment().diff(new Date(Number(session)).toString(), 'seconds')
    if (session > 900) {//15mins
      this.props.actions.signOut();
      this.props.history !== undefined && this.props.history.push("/")
      this.authenticate();
    }
  };
  componentDidMount = () => {
    this.authenticate();
    this.setState({ isMobileOrTablet: this.checkIfMobileOrTablet() });
    //  window.onbeforeunload = this.handleLeavePage;
  }

  handleLeavePage = e => {
    e.preventDefault()
    if (!this.props.rememberMe) {
      localStorage.clear()
    }
  }

  authenticate = () => {
    if (localStorage.getItem("authToken")) {
      UtilityService.getUserInfo()
        .then(response => {
          if (response.status == 200) {
            let userDetails = {
              _id: response.text.data._id,
              firstName: response.text.data.firstName,
              lastName: response.text.data.lastName,
              userId: "",
              authToken: localStorage.getItem("authToken"),
              profilePicture: response.text.data.profilePicture,
              rememberMe: response.text.data.rememberMe,
              isLoggedIn: true,
              rights: response.text.data.rights
            }
            this.props.actions.updateBasicDetails(userDetails)
            this.setState({ loaded: true })
          }
          if (response.status === 401) {
            let userDetails = {
              isLoggedIn: false
            }
            this.props.actions.updateBasicDetails(userDetails)
          }
        })
        .catch(error => {
          this.props.actions.updateBasicDetails({ isLoggedIn: false })
          this.setState({ error: true })
          UtilityService.errorMsg(this.msg)
        })
    } else {
      let userDetails = {
        isLoggedIn: false
      }
      this.props.actions.updateBasicDetails(userDetails)
    }
  }

  //Alert message of return api
  getalertMessage = (msgType, msg, time) => {
    if (msgType == "success") {
      UtilityService.successMsg(this.msg, msg, time)
    } else if (msgType == "error") {
      UtilityService.errorMsg(this.msg, msg, time)
    } else if (msgType == "info") {
      UtilityService.infoMsg(this.msg, msg, time)
    } else if (msgType == "warning") {
      UtilityService.warningMsg(this.msg, msg, time)
    } else if (msgType == "edit") {
      UtilityService.editMsg(this.msg, msg, time)
    } else if (msgType == "delete") {
      UtilityService.deleteMsg(this.msg, msg, time)
    }
  }

  unauthorisedFunc = () => {
    let session = localStorage.getItem("session");
    session = moment().diff(new Date(Number(session)).toString(), 'seconds')
    if (session >= 900) {//15mins
      localStorage.removeItem("authToken")
      localStorage.clear()
      this.props.actions.signOut()
      history !== undefined && history.push("/")
    }

  }


  // Function to detect if the device is a mobile or tablet
  checkIfMobileOrTablet() {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

   HomeRoute = () => {
    return this.state.isMobileOrTablet ? <MobileQRScanner /> : <Dashboard />;
  };

  render() {
    const authorised_rout = (
      <div id="toggle-nav-bar">
        <AlertContainer ref={a => (this.msg = a)} {...Alert} />

        {/* <Header {...this.props} />

        <Sidebar {...this.props} /> */}


        {/* Show Header and Sidebar only on Desktop */}
        {!this.state.isMobileOrTablet && (
            <React.Fragment>
              <Header {...this.props} />
              <Sidebar {...this.props} />
            </React.Fragment>
          )}



        <Switch>
          {/* Dashboard */}
          <Route exact path="/" component={this.HomeRoute} />

          {/* Profile */}
          <Route
            path="/profile"
            render={props => (
              <Profile
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* LIST FOR ALL MODULES */}
          <Route
            path="/list"
            render={props => (
              <List
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* Customer */}
          <Route
            path="/CustomerPage"
            render={props => (
              <Customer
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* Meeting room */}
          <Route
            path="/MeetingNote"
            render={props => (
              <MeetingNote
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* <Route
            path="/EditMeeting"
            render={props => (
              <EditMeeting
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          /> */}

          {/* <Route
            path="/viewMeeting"
            render={props => (
              <EditMeeting
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          /> */}

          <Route path="/calendar" component={Calendar} />
          <Route path="/communication" component={Communication} />
          <Route path="/chat" component={Chat} />

          {/* Style */}
          <Route
            path="/StylePage"
            render={props => (
              <Style
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* <Route path="/viewStyle" component={ViewStyle} /> */}
          {/* <Route path="/editStyle" component={EditStyle} /> */}

          {/* IB */}
          <Route
            path="/createIB"
            // component={CreateIB}
            render={props => (
              <CreateIB
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* <Route path="/listIB" component={ListIB} /> */}

          {/* SMVCalc & Thread  */}
          <Route path="/smv_ov_list" component={Smv_Ov_List} />
          <Route
            path="/SmvThread"
            render={props => (
              <SmvThread
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />
          {/* <Route path="/viewSMV" component={ViewSMV} /> */}
          {/* <Route path="/editSMV" component={EditSMV} /> */}

          {/* Embroidery */}
          {/* <Route path="/addEmbroidery" component={AddEmbroidery} />
          {/* <Route path="/listEmbroidery" component={ListEmbroidery} /> */}
          {/* <Route path="/viewEmbroidery" component={ViewEmbroidery} /> */}
          {/* <Route path="/editEmbroidery" component={EditEmbroidery} /> */}

          {/* Technical issues */}
          <Route
            path="/technicalIssues"
            render={props => (
              <TechnicalIssues
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* Sample */}
          <Route
            path="/Sample"
            render={props => (
              <Sample
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* <Route path="/viewSample" component={ViewSample} />

          <Route path="/editSample" component={EditSample} /> */}

          {/* Permission role */}
          {/* <Route path="/listPermissionRole" component={ListPermissionsRole} /> */}
          <Route
            path="/permissionRole"
            render={props => (
              <PermissionRole
                getalertMessage={this.getalertMessage}
                {...props}
              />
            )}
          />

          {/* Costing */}
          <Route
            path="/CostingPage"
            render={props => (
              <Costing
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />
          {/* <Route path="/listCost" component={CostList} /> */}
          {/* <Route path="/viewCost" component={ViewCost} />
          <Route path="/editCost" component={EditCost} /> */}
          <Route
            path="/CostingComparison"
            render={props => (
              <CostingComparison
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* CAD */}
          <Route
            path="/developmentCad"
            render={props => (
              <DevelopmentCAD
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* <Route path="/viewCAD" component={ViewCAD} />
          <Route path="/editCAD" component={EditCAD} /> */}

          {/* Fabric */}
          <Route
            path="/developmentFabric"
            render={props => (
              <DevelopmentFabric
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          <Route
            path="/bulkImport"
            render={props => (
              <BulkImport
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />
          <Route
            path="/printFabricNumber"
            render={props => (
              <PrintFabricNumber
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />
          <Route
            path="/printStyleNumber"
            render={props => (
              <PrintStyleNumber
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* Bnumber  */}
          <Route
            path="/BNumber"
            render={props => (
              <DevelopmentBNumber
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />
          {/* Measurement chat */}
          <Route
            path="/measurementChat"
            render={props => (
              <MeasurementModal
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
                />
            )}
            />
            {/* MobileApp */}
            <Route
            path="/mobileApp"
            render = {props => (
              <SampleMobileApp
              getalertMessage={this.getalertMessage}
              unauthorisedFunc={this.unauthorisedFunc}
              {...props}
              />
            )}
            />


          {/* MobileLogin */}
          <Route
            path="/mobileLogin"
            render = {props => (
              <MobileLogin
              getalertMessage={this.getalertMessage}
              unauthorisedFunc={this.unauthorisedFunc}
              {...props}
              />
            )}
            />



            {/* Scanner */}
            <Route
            path="/qr"
            render = {props => (
              <MobileQRScanner
              getalertMessage={this.getalertMessage}
              unauthorisedFunc={this.unauthorisedFunc}
              {...props}
              />
            )}
            />

          {/* Trim */}
          <Route
            path="/Trim"
            render={props => (
              <Trim
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* Sourcing */}
          <Route
            path="/developmentSourcing"
            render={props => (
              <DevelopmentSourcing
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* Product */}
          <Route path="/developmentProduct" component={DevelopmentProduct} />
          {/* <Route
            path="/viewDevelopmentProduct"
            component={ViewDevelopmentProduct}
          />
          <Route
            path="/editDevelopmentProduct"
            component={EditDevelopmentProduct}
          /> */}
          {/*
          <Route path="/viewProduct" component={ViewProduct} />
          <Route path="/editProduct" component={EditProduct} />
          <Route path="/listProduct" component={ListDevelopmentProduct} /> */}

          {/* Employee */}
          <Route
            path="/employeRights"
            render={props => (
              <EmployeRights
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />
          <Route
            path="/employee"
            render={props => (
              <Employee
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />
          <Route
            path="/newdashboard"
            render={props => (
              <NewDashboard
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />
          <Route
            path="/newsamplerequest"
            render={props => (
              <NewSampleRequest
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />
          <Route
            path="/newemployee"
            render={props => (
              <NewEmployee
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />
          <Route path="/generateTag" component={GenerateTag} />

          {/* Sytem supplier */}
          <Route
            path="/system/Supplier"
            render={props => (
              <SystemSupplier
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* System Rest of module */}
          <Route
            path="/system"
            render={props => (
              <SystemSubmodulesPage
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* System list rest of module */}
          <Route
            path={[
              "/3D",
              "/cad",
              "/general",
              "/COSTING",
              "/CUSTOMER",
              "/STYLE",
              "/EMBROIDERY",
              "/TRIMS",
              "/FABRIC",
              "/samplerequest"
            ]}
            render={props => (
              <SystemCategoryList
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* Sytem add edit module */}
          <Route
            path={["/VIEW", "/EDIT", "/ADD"]}
            render={props => (
              <AddCategory
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* Fabric Report */}
          <Route
            path="/Report"
            render={props => (
              <Report
                getalertMessage={this.getalertMessage}
                unauthorisedFunc={this.unauthorisedFunc}
                {...props}
              />
            )}
          />

          {/* PageNotFound */}
          <Route render={props => <PageNotFound error={404} {...props} />} />
        </Switch>

        {/* <Footer /> */}
      </div>
    )
    const unauthorised_rout = (
      <div>
        <AlertContainer ref={a => (this.msg = a)} {...Alert} />
        <Switch>
          <Route
            exact
            path="/"
            render={props =>this.state.isMobileOrTablet ? (
              <MobileLogin getalertMessage={this.getalertMessage} {...props} />
            ) : (
              <LogInPage getalertMessage={this.getalertMessage} {...props} />
            )
          }
          />
          <Route render={props => <PageNotFound error={404} {...props} />} />
        </Switch>
      </div>
    )
    return (
      <Router history={history}>
        {this.props.isLoggedIn === null ? (
          this.state.error ? (
            <PageNotFound error={500} />
          ) : (
              <Loading />
            )
        ) : this.props.isLoggedIn ? (
          authorised_rout
        ) : (
              unauthorised_rout
            )}
      </Router>
    )
  }
}

const mapStateToProps = state => {
  return {
    isLoggedIn: state.main.isLoggedIn,
    rememberMe: state.main.rememberMe
  }
}
const mapDispatchToProps = dispatch => {
  return { actions: bindActionCreators(mainAction, dispatch) }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Routes)


// WEBPACK FOOTER //
// ./src/Routes.js